import { SVG } from "./index.styles";

export type Props = {
	color?: string;
	width?: number;
	height?: number;
};

export default SVG;
